import React from 'react';
import InfoText from '@/components/atoms/InfoText';

export default function Header({
  icon,
  title,
  subTitle,
  filters,
}: {
  icon?: React.ReactElement;
  title?: string;
  subTitle?: string;
  filters?: React.ReactElement;
}) {
  return (
    <header
      className="flex flex-col gap-4 sm:gap-0 sm:flex-row sm:justify-between sm:items-center"
      data-testid="post-details-header"
    >
      {/* Icon and title */}
      <div
        className="flex items-center gap-2"
        data-testid="post-details-header-title-group"
      >
        {icon}

        <div className="flex flex-col" data-testid="post-details-header-text">
          {title && (
            <InfoText
              text={title}
              className="!text-[18px] !leading-[100%] !text-light-text-primary dark:!text-dark-text-primary !font-bold"
              data-testid="post-details-header-title"
            />
          )}

          {subTitle && (
            <InfoText
              text={subTitle}
              className="!text-[16px] !leading-[100%] !text-light-text-primary dark:!text-dark-text-primary !font-normal"
              data-testid="post-details-header-subtitle"
            />
          )}
        </div>
      </div>

      {/* Filters  */}
      {filters}
    </header>
  );
}
